//指引内容管理
export const newGuidanceOption = (safe) => {
	return {
		card: true,
		border: true,
		index: false,
		stripe: true,
		menuAlign: 'center',
		searchLabelWidth: 120,
		searchMenuSpan: 24,
		searchMenuPosition: 'right',
		labelWidth: 140,
		align: 'center',
		excelBtn: true,
		column: [
			{
				label: '内容标题',
				prop: 'name',
				search: true,
				rules: [
					{
						required: true,
						message: '请输入内容标题',
						trigger: 'blur',
					},
				],
			},
			{
				label: '内容上传',
				prop: 'file',
				type: 'upload',
				limit: 1,
				action: '/dist/maintenance/uploadFile',
				hide: true,
				showColumn: false,
				tip: '请上传mp4或者pdf',
				accept: ['.mp4', '.pdf'],
				rules: [
					{
						required: true,
						message: '请选择要上传的内容',
						trigger: 'blur',
					},
				],
			},

			{
				label: '文件类型',
				prop: 'fileType',
				editDisplay: false,
				addDisplay: false,
				formatter: (row) => {
					return row.file.substring(row.file.lastIndexOf('.') + 1)
				},
			},

			{
				label: '备注',
				prop: 'remark',
				type: 'textarea',
				span: 24,
			},
			{
				label: '使用权限',
				prop: 'useAuth',
				type: 'checkbox',
				dicData: [
					{
						label: '主渠道管理员',
						value: 'ROLE_ADMIN',
					},
					{
						label: '子渠道管理员',
						value: 'ROLE_PLACE_ADMIN',
					},
					{
						label: '内勤人员',
						value: 'ROLE_STAFF',
					},
				],
				rules: [
					{
						required: true,
						message: '请选择使用权限',
						trigger: 'blur',
					},
				],
			},
			{
				label: '状态',
				prop: 'status',
				type: 'switch',
				value: 0,
				rules: [
					{
						required: true,
						message: '请选择状态',
						trigger: 'blur',
					},
				],
				dicData: [
					{
						label: '关闭',
						value: 1,
					},
					{
						label: '开启',
						value: 0,
					},
				],
			},
		],
	}
}
